import React from "react";
import Landing from "../landing/Landing";

const Home = ({ isLoggedIn }) => {
  return <Landing isLoggedIn={isLoggedIn} />;
};

export default Home;
